import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.jpeg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path) => {
    return location.pathname === path
      ? 'text-blue-300'
      : 'text-white';
  };

  return (
    <nav className="sticky top-0 z-50 shadow-lg">
      <div className="flex w-full items-center px-2 md:px-4 py-2 bg-[rgb(0,39,68)]">        
      {/* Logo Section (White Background) */}
        <div className="bg-white rounded-lg px-3 md:px-5 py-3 flex items-center">
          <img 
            src={logo} 
            alt="Netbernet Logo" 
            className="h-8 md:h-12 w-auto object-contain"
          />
        </div>
        {/* Menu Section (Dark Blue Background, No Border) */}
        <div className="flex-1 flex items-center justify-center rounded-r-lg" style={{ backgroundColor: 'rgb(0,39,68)', borderTopRightRadius: '8px', borderBottomRightRadius: '8px' }}>
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-12 w-full justify-center">
            <Link to="/" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/')}`}>Home</Link>
            <Link to="/solutions" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/solutions')}`}>Solutions</Link>
            <Link to="/services" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/services')}`}>Services</Link>
            <Link to="/erp-services" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/erp-services')}`}>ERP Services</Link>
            <Link to="/about" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/about')}`}>About Us</Link>
            <Link to="/blog" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/blog')}`}>Blog</Link>
            <Link to="/contact" className={`text-lg font-medium hover:text-blue-300 transition-colors ${isActive('/contact')}`}>Contact</Link>
          </div>
          {/* Mobile Hamburger */}
          <div className="md:hidden flex items-center w-full justify-end pr-4">
            <button onClick={toggleMenu} className="text-white focus:outline-none">
              {isOpen ? (
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 rounded-b-lg shadow-lg">
          <div className="flex flex-col items-center py-4" style={{ backgroundColor: 'rgb(0,39,68)' }}>
            <Link to="/" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>Home</Link>
            <Link to="/solutions" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>Solutions</Link>
            <Link to="/services" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>Services</Link>
            <Link to="/erp-services" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>ERP Services</Link>
            <Link to="/about" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>About Us</Link>
            <Link to="/blog" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>Blog</Link>
            <Link to="/contact" className="text-white text-lg font-medium py-2 w-full text-center hover:text-blue-300" onClick={toggleMenu}>Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
